import { render } from "./SuppliersListPage.vue?vue&type=template&id=71109605&ts=true"
import script from "./SuppliersListPage.vue?vue&type=script&lang=ts"
export * from "./SuppliersListPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__